module.exports = __webpack_public_path__ + "static/media/logo-brand.af94b300.svg";